import { render, staticRenderFns } from "./material_table.vue?vue&type=template&id=537424fd&scoped=true"
import script from "./material_table.vue?vue&type=script&lang=js"
export * from "./material_table.vue?vue&type=script&lang=js"
import style0 from "./material_table.vue?vue&type=style&index=0&id=537424fd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537424fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537424fd')) {
      api.createRecord('537424fd', component.options)
    } else {
      api.reload('537424fd', component.options)
    }
    module.hot.accept("./material_table.vue?vue&type=template&id=537424fd&scoped=true", function () {
      api.rerender('537424fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/material_table.vue"
export default component.exports